import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  prevent(event) {
    const currentPath = window.location.pathname
    const linkPath = new URL(this.element.href).pathname

    if (currentPath === linkPath) {
      event.preventDefault()
    }
  }
}